export default {
  base64: 'base64',
  url: 'url'
}